import React, { Component } from 'react'
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { Link } from "react-router-dom";
import TextField from 'material-ui/TextField';
import './profile_styles.css';

class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      email: '',
    }
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

render() {
  return (
      <div className="container">
          <p className="header"> Profile Information</p>
          <br />

          <span>
            <b>Name:</b>
            &nbsp;&nbsp;
            <TextField
            id='1'
            defaultValue={this.props.user.displayName}
            onChange={this.handleChange('name')}
            />
           </span>
           <br />

           <span>
           <b>Email:</b>
           &nbsp;&nbsp;
           <TextField
           id='2'
           defaultValue={this.props.user.email}
           onChange={this.handleChange('email')}
          />
          </span>
          <br />

           <span>
           <b>Phone:</b>
           &nbsp;&nbsp;
           <TextField
           id='3'
           defaultValue={this.props.phone}
           onChange={this.handleChange('phone')}
          />
          </span>
          <br />

          <span>
          <b>Hours:</b>
          &nbsp;&nbsp;
          <TextField
          id='4'
          defaultValue={this.props.hours/3600}
          onChange={this.handleChange('hours')}
         />
         </span>
         <br />
         <br />

         <RaisedButton label="Save Profile Changes" primary={true} onClick={() => alert('hey')}/>
         &nbsp;
         <a href="https://www.mymozak.com/plans.html" target="_blank" rel="noopener noreferrer" >
         <FlatButton
         label="Purchase More Hours" primary={true}
         />
         </a>
     </div>
  )
}

}

const mapStateToProps = ({auth}) => {
  return auth

}

export default connect(mapStateToProps, {})(Profile);



// WEBPACK FOOTER //
// ./src/components/profile/index.js